/* global firebaseui firebase */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import firebaseui from 'firebaseui';
import firebase from 'firebase';
import { history } from '../history';
// import Modal
import config, { FIREBASE_AUTH_CONTAINER } from '../../config';


class AuthComponent extends Component {

    constructor(props) {

        super(props);

        this.state = {
            ui: null,
            redirTo: ''
        }

    }

    componentDidMount() {

        const redirTo = this.props.location.hash.split('=')[1]
        if (redirTo)
            this.setState({redirTo})

        const ui = new firebaseui.auth.AuthUI(firebase.auth())
        this.setState({ ui })

        ui.start('#' + FIREBASE_AUTH_CONTAINER, {
            autoUpgradeAnonymousUsers: true,
            callbacks: {
                signInFailure: function(error) {
                    
                    // console.log(error)
                    if (error.code != 'firebaseui/anonymous-upgrade-merge-conflict') {
                        return Promise.resolve();
                      }
                      // The credential the user tried to sign in with.
                      var cred = error.credential;
                      // If using Firebase Realtime Database. The anonymous user data has to be
                      // copied to the non-anonymous user.
                      var app = firebase.app();
                      // Save anonymous user data first.
                      return app.database().ref('users/' + firebase.auth().currentUser.uid)
                          .once('value')
                          .then(function(snapshot) {
                            data = snapshot.val();
                            // This will trigger onAuthStateChanged listener which
                            // could trigger a redirect to another page.
                            // Ensure the upgrade flow is not interrupted by that callback
                            // and that this is given enough time to complete before
                            // redirection.
                            return firebase.auth().signInWithCredential(cred)

                          .then(function(user) {
                            // Original Anonymous Auth instance now has the new user.
                            return app.database().ref('users/' + user.uid).set(data);
                          })
                          .then(function() {
                            // Delete anonymnous user.
                            return anonymousUser.delete();
                          }).then(function() {
                            // Clear data in case a new user signs in, and the state change
                            // triggers.
                            data = null;
                            // FirebaseUI will reset and the UI cleared when this promise
                            // resolves.
                            // signInSuccess will not run. Successful sign-in logic has to be
                            // run explicitly.
                            window.location = this.state.redirTo || '/'
                          });

                        })

                },
                signInSuccessWithAuthResult: (authResult, redirectUrl) => {

                    // location.href = '/'
                    window.location = this.state.redirTo || '/'
                    // User successfully signed in.
                    // Return type determines whether we continue the redirect automatically
                    // or whether we leave that to developer to handle.
                    // return true;
                    // firebase.functions().httpsCallable('checkUser')({ "email": authResult.user.email, "uid": authResult.user.uid }).then(function (result) {

                    //     console.log("result" + JSON.stringify(result));
                    //     if (result.data.auth === true) {

                    //         console.log("Successfully fetched user data");
                    //         return false;

                    //     } else {
                    //         console.log("Error fetching user data:");
                    //         return false;
                    //     }

                    // }).catch(function (error) {

                    //     // Getting the Error details.
                    //     var code = error.code;
                    //     var message = error.message;
                    //     var details = error.details;
                    //     // ...
                    //     console.log(message);

                    // });
                },
                uiShown: function () { },
            },
            // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
            signInFlow: 'popup',
            signInSuccessUrl: this.state.redirTo || '/',
            signInOptions: [
                // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                // firebase.auth.EmailAuthProvider.PROVIDER_ID,
                // firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                firebase.auth.EmailAuthProvider.PROVIDER_ID
            ],
            // Terms of service url.
            tosUrl: '/terms-of-service'

        })

    }

    componentWillUnmount() {

        this.state.ui.delete()

    }

    onUiShown() {
        // The widget is rendered.
        // Hide the loader.
        // document.getElementById('loader').style.display = 'none';
    }

    render() {
        return (
            // <Modal
            <div id={FIREBASE_AUTH_CONTAINER}></div>
        );
    }
}


const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({

});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AuthComponent);


// WEBPACK FOOTER //
// ./src/components/auth/auth.js